import React, { FC, memo } from 'react';
import triggerTracking from '@blueprint/tracking';
import { Icon } from '@blueprint/ui';

import { getTranslator } from '../../../shared/i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import { StyledMapIconLink } from './MapIcon.styles';

type mapIconProps = {
    href: string;
};

const t = getTranslator(searchTranslations);

const MAP_VIEW_TEXT = t('resultsMeta.map');

export const MapIcon: FC<mapIconProps> = memo(({ href }) => {
    return (
        <StyledMapIconLink
            variant="tertiary"
            href={href}
            data-testid="map-view-link"
            rel={'nofollow'}
            onClick={() =>
                triggerTracking({
                    event: 'GAEvent',
                    eventCategory: 'search results',
                    eventAction: 'clickthrough',
                    eventLabel: 'view_type_map'
                })
            }
        >
            <Icon iconId="location_pin" size="small" />
            {MAP_VIEW_TEXT}
        </StyledMapIconLink>
    );
});

MapIcon.displayName = 'MapIconComponent';
